// src/utils/enderecoUtils.js
const textoLimpo = (valor) => (valor ?? '').toString().trim();

export const comporEnderecoCliente = ({ logradouro, numero, bairro, complemento } = {}) => {
  const partes = [];
  const rua = textoLimpo(logradouro);
  const numeroLimpo = textoLimpo(numero);
  const bairroLimpo = textoLimpo(bairro);
  const complementoLimpo = textoLimpo(complemento);

  if (rua) partes.push(rua);
  if (numeroLimpo) partes.push(`nº: ${numeroLimpo}`);
  if (bairroLimpo) partes.push(`Bairro: ${bairroLimpo}`);
  if (complementoLimpo) partes.push(`Complemento: ${complementoLimpo}`);

  return partes.join(', ');
};

export const decomporEnderecoCliente = (enderecoCliente = '') => {
  const partes = textoLimpo(enderecoCliente).split(',').map(textoLimpo).filter(Boolean);
  const endereco = { logradouro: '', numero: '', bairro: '', complemento: '' };

  if (partes.length === 0) return endereco;

  endereco.logradouro = partes[0];
  const possuiCamposIdentificados = partes.slice(1).some((parte) => /^(?:n[º°o]\s*:|bairro\s*:|complemento\s*:)/i.test(parte));

  if (!possuiCamposIdentificados) {
    endereco.numero = partes[1] || '';
    endereco.bairro = partes[2] || '';
    endereco.complemento = partes.slice(3).join(', ');
    return endereco;
  }

  const complementos = [];
  partes.slice(1).forEach((parte) => {
    if (/^n[º°o]\s*:/i.test(parte)) endereco.numero = parte.replace(/^n[º°o]\s*:/i, '').trim();
    else if (/^bairro\s*:/i.test(parte)) endereco.bairro = parte.replace(/^bairro\s*:/i, '').trim();
    else if (/^complemento\s*:/i.test(parte)) complementos.push(parte.replace(/^complemento\s*:/i, '').trim());
    else complementos.push(parte);
  });
  endereco.complemento = complementos.filter(Boolean).join(', ');

  return endereco;
};

export const enderecoPessoaParaCampos = (endereco = {}) => ({
  logradouro: textoLimpo(endereco?.logradouro),
  numero: textoLimpo(endereco?.numero),
  bairro: textoLimpo(endereco?.bairro),
  complemento: textoLimpo(endereco?.complemento),
});
